import { useCallback, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ApplicationStatusModel } from '@n2-common/serverGeneratedTypings/applicationStatusModel';
import { Button, ButtonRowContainer, Headline } from '@n2-common/ui';
import { N2ApplicationStatus } from '@n2-common/serverGeneratedTypings/n2ApplicationStatus';
import { fetchApplicationStatusAndRedirectIfNotExpectedState } from '@n2-common/applicationPages/applicationStatusHelpers';
import style from './style.module.scss';
import { useApplicationIdContext } from '@n2-common/components/ApplicationContext';
import { SelectOfferSlider } from '@n2-common/components';
import { OfferBox } from './OfferBox';
import { ApplicationPaths, navigateToStep } from '@n2-common/applicationPages/ApplicationFormsHelpers';
import { navigateToCorrectStep } from '../../App';
import { logErrorToServerside } from '@n2-common/services/serverSideLogging';
import { trackSectionView } from '@n2-common/lib/gtm';
import { N2Product } from '@n2-common/serverGeneratedTypings/n2Product';
import { SelectOffer } from '@n2-common/services/legacyApplicationApiService';
import { Offer as OfferType } from '@n2-common/serverGeneratedTypings/offer';

export function applicationIsInValidStateForOffer(applicationStatus: ApplicationStatusModel) {
    if (applicationStatus.Product !== N2Product.Loan) {
        return false;
    }

    if(applicationStatus.Status == N2ApplicationStatus.ReadyForSigning && applicationStatus.ApplicantCddPending){
        return true;
    }

    if (applicationStatus.Status === N2ApplicationStatus.Offer) {
        return true;
    }
    return false;
}

export function Offer(): JSX.Element {
    const { applicationId, applicantId, country, productType } = useApplicationIdContext();

    const [applicationStatus, setApplicationStatus] = useState<ApplicationStatusModel | null>(null);
    const navigate = useNavigate();
    const [selectedOffer, setSelectedOffer] = useState<OfferType>();

    useEffect(() => {
        document.title = 'Tilbud';
    }, []);

    useEffect(() => {
        trackSectionView(productType, country, '2.0', 'Offer');
    }, [country, productType]);

    useEffect(() => {
        fetchApplicationStatusAndRedirectIfNotExpectedState(
            applicationId,
            applicantId,
            applicationIsInValidStateForOffer,
            setApplicationStatus,
            navigate,
            navigateToCorrectStep
        );
    }, [applicationId, navigate, applicantId]);

    const onSubmit = useCallback(() => {
        if (!selectedOffer) {
            return;
        }
        SelectOffer(applicationId, applicantId, selectedOffer.OfferGuid).then(() => {
            navigateToStep(ApplicationPaths.cdd, applicationId, navigate, applicantId);
        });
    }, [applicantId, applicationId, navigate, selectedOffer]);

    useEffect(() => {
        if (!applicationStatus) {
            return;
        }
        if (applicationStatus.OfferedAmount === null) {
            logErrorToServerside('Offered amount is null on offer-page, that should not happen', applicationId, applicantId, {});
        }
    }, [applicationStatus, applicantId, applicationId]);

    return (
        <>
            {applicationStatus && applicationId ? (
                <div className={style.wrapper}>
                    <Headline>Gratulerer, dette er lovende!</Headline>
                    <ButtonRowContainer>
                        <Button className={style.nextButton} uiType="primary" onClick={() => onSubmit()}>
                            Fullfør søknaden
                        </Button>
                    </ButtonRowContainer>
                    <SelectOfferSlider applicationStatus={applicationStatus} onError={console.warn} onOffer={setSelectedOffer} />
                    {selectedOffer && (
                        <>
                            <OfferBox offer={selectedOffer} />
                        </>
                    )}
                </div>
            ) : (
                <></>
            )}
        </>
    );
}
